import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';

import KeyFigure from './key-figure/key-figure.container';
import './key-figure-visualizer.css';

const styles = {
  grid: {
    display: 'grid',
    gridColumnGap: '20px',
  },
};

const checkIsNumber = value => typeof (value) === 'number' && Number.isFinite(value);

const getComparisonValues = (data, i) => {
  const result = [];

  for (let j = 1; j < data.length; j++) {
    if (data[j][i]) {
      result.push(data[j][i].value);
    }
  }

  return result;
};

const getKeyFigures = (data, options) => {
  const result = data[0].map((kf, i) => {
    const keyFigure = kf.value;

    const isText = !checkIsNumber(keyFigure);
    const comparisonValues = getComparisonValues(data, i);
    return {
      title: kf.name,
      keyFigure,
      comparisonValues,
      ...options[i],
      isText,
    };
  });
  return result;
};

const getGridColumns = (length) => {
  if (length % 2 === 0) {
    return '1fr 1fr';
  }
  if (length % 3 === 0) {
    return '1fr 1fr 1fr';
  }
  return '1fr';
};

function KeyFigureVisualizer(props) {
  const useDesktopLayout = useMediaQuery('(min-width:1200px)');
  const {
    data, options, useMultiLocationComparison, reportDataId,
  } = props;

  const keyFigures = getKeyFigures(data, options);
  const rows = keyFigures.map((kf, index) => <KeyFigure key={kf.title} keyFigure={kf} hideIcon={!!reportDataId} index={index}/>);

  let style = styles.grid;
  if (useDesktopLayout && !useMultiLocationComparison) {
    style = {
      gridTemplateColumns: getGridColumns(keyFigures.length),
      ...styles.grid,
    };
  }

  return (
    <div style={style}>
      {rows}
    </div>
  );
}

KeyFigureVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  useMultiLocationComparison: PropTypes.bool.isRequired,
  reportDataId: PropTypes.number,
};

KeyFigureVisualizer.defaultProps = {
  data: [],
  options: [],
  reportDataId: null,
};

export default KeyFigureVisualizer;
